import React, { useEffect, createRef } from 'react';
import Modal from 'library/components/modal';
import * as StyledConfirmationModal from 'apps/journey/components/modals/styled-confirmation-modal';
import { bool, func, node, string } from 'prop-types';

const ConfirmationModal = (props) => {
  const {
    active,
    toggleActive,
    children,
    handleSubmit,
    customIcon,
    customColor,
    cancelText = 'No, cancel',
    confirmText = 'Yes',
  } = props;

  const modalRef = createRef(null);

  useEffect(() => {
    if (modalRef && modalRef.current && active) {
      modalRef.current.focus();
      console.log('focusing');
    }
  }, [active]);

  return (
    <Modal
      active={active}
      role="alertdialog"
      aria-describedby="confirmationText"
      onClose={toggleActive}
    >
      <StyledConfirmationModal.Body>
        <StyledConfirmationModal.DismissIcon
          customColor={customColor}
          height={56}
          onClick={toggleActive}
        >
          {customIcon || <StyledConfirmationModal.RemoveSvg />}
        </StyledConfirmationModal.DismissIcon>
        <StyledConfirmationModal.Content role="document" ref={modalRef}>
          <StyledConfirmationModal.ConfirmationText id="confirmationText">
            {children}
          </StyledConfirmationModal.ConfirmationText>
          <StyledConfirmationModal.ButtonRow>
            <button className="cancelButton" onClick={toggleActive}>
              {cancelText}
            </button>
            <button className="confirmButton" onClick={handleSubmit}>
              {confirmText}
            </button>
          </StyledConfirmationModal.ButtonRow>
        </StyledConfirmationModal.Content>
      </StyledConfirmationModal.Body>
    </Modal>
  );
};

ConfirmationModal.propTypes = {
  active: bool,
  toggleActive: func,
  children: node,
  handleSubmit: func,
  cancelText: string,
  confirmText: string,
  customIcon: node,
  customColor: string,
};

export default ConfirmationModal;
